import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { findAirlines } from "../services/airlines";
import { addToSuggestions, AirlineSuggestion } from "../suggestions";

const airlinesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const initialState = {
  ...airlinesAdapter.getInitialState(),
  byTktNumber: {},
};

const airlinesSlice = createSlice({
  name: "airlines",
  initialState,
  reducers: {
    setAirlines: (state, { payload: airlines }) => {
      state.byTktNumber = airlines.reduce(
        (acc, { id, tkt }) => ({ ...acc, [tkt]: id }),
        {},
      );
      airlinesAdapter.setAll(state, airlines);
    },
  },
});

export default airlinesSlice.reducer;

export const { setAirlines } = airlinesSlice.actions;

export const selectors = airlinesAdapter.getSelectors(
  (state) => state.airlines,
);

export const loadAirlines = createAsyncThunk(
  "airlines/loadAll",
  (_, { dispatch }) =>
    findAirlines().then((airlines) => {
      addToSuggestions(airlines.map(AirlineSuggestion));
      dispatch(setAirlines(airlines));
    }),
);

export const selectAirlineByTktNumber = (state, tktNumber) => {
  const id = state.airlines.byTktNumber[tktNumber];
  return selectors.selectById(state, id);
};
